/**
 * Imports a chunked component async
 *
 * @param name - Name of the Javascript file
 * @param el - Name of the element
 * @returns {Promise.<*>}
 */
export default async function importComponent(name, el = null) {
  if (el) {
    if (!exists(el)) return;
  } else {
    throw new Error('You must pass an element in.');
  }

  if (Array.isArray(name)) {
    const imports = [];

    name.forEach(v => {
      imports.push(import(`../components/${v}`));
    });

    return await Promise.all(imports)
      .then(resp => {
        const component = [];

        resp.forEach(v => {
          component.push(v.default);
        });

        return {
          component,
          el
        };
      })
      .catch(err => {
        Promise.reject(new Error(`There was an error loading your component - ${err}`));
      });
  }

  return await import(`../components/${name}`)
    .then(component => {
      return {
        component: component.default,
        el
      };
    })
    .catch(err => {
      Promise.reject(new Error(`There was an error loading your component - ${err}`));
    });
}

/**
 * Check if an element exists in the DOM tree
 *
 * @param el - DOM element
 * @returns {boolean}
 */
export const exists = el => {
  if (typeof el !== 'string') {
    return el.length > 0;
  }
  return document.querySelector(el) !== null;
};

/**
 * Renders component with callback
 *
 * @param el - Name of the element
 * @param cb - Callback
 */
export function render(el, cb){
  let elements;
  if (typeof el === 'string') {
    elements = document.querySelectorAll(el);
  } else {
    elements = el;
  }
  const length = elements.length;

  for(let i = 0; i < length; ++i) {
    cb($(elements[i]));
  }
}



// WEBPACK FOOTER //
// ./src/ktu/js/helpers/bootstrap.js